import { useNavigation } from '@react-navigation/native';
import AccountContext from 'context/AccountContext';
import useAfterAuthenticationRedirect from 'hooks/useAfterAuthenticationRedirect';
import { useContext } from 'react';
import { usePaymentStore } from 'stores/paymentStore';
import { OnboardingNavProps } from 'types/navigation';

const useOnboardingRedirect = () => {
  const { navigate } = useNavigation<OnboardingNavProps>();
  const {
    customer: { vehicles },
  } = useContext(AccountContext);
  const { skipOnboarding } = useAfterAuthenticationRedirect();

  const handleSuccessNavigationAfterAddCard = async () => {
    navigate('addCardDetailsOnboarding');
  };

  const handleSuccessNavigationAfterAddCardDetails = async () => {
    const hasVehicles = vehicles && vehicles.length > 0;
    if (hasVehicles) {
      await skipOnboarding();
    } else {
      return navigate('onboardingContinue');
    }
  };

  const handleFailureNavigationAfterAddCard = () => {
    usePaymentStore.getState().setCreditCardCreationTerminalUrl(undefined);
    return navigate('addPaymentMethod');
  };

  return {
    handleSuccessNavigationAfterAddCard,
    handleFailureNavigationAfterAddCard,
    handleSuccessNavigationAfterAddCardDetails,
  };
};

export default useOnboardingRedirect;
